import { FC, useState } from "react";
import useI18n from "../../hooks/useTranslations";
import ModalDialog from "../ui/ModalDialog";
import ConfigurationSharingAccessesContent from "./ConfigurationSharingAccessesContent";

interface ConfigurationSharingAccessesDialogProps {
  configurationId: string;
  configurationName?: string;
  isAdmin?: boolean;
  onClose: () => void;
}

const ConfigurationSharingAccessesDialog: FC<ConfigurationSharingAccessesDialogProps> = ({
  configurationId,
  configurationName,
  isAdmin,
  onClose,
}) => {
  const i18n = useI18n();
  const [isReady, setIsReady] = useState(false);
  const onContentReady = () => setIsReady(true);

  if (!isReady) {
    return (
      <div style={{ display: "none" }}>
        <ConfigurationSharingAccessesContent configurationId={configurationId} isAdmin={isAdmin} onReady={onContentReady} />
      </div>
    );
  }

  return (
    <ModalDialog
      onClose={onClose}
      fitContent
      title={
        configurationName
          ? `${i18n.translation.projects.editSharings}: ${configurationName}`
          : i18n.translation.projects.editSharings
      }
    >
      <ConfigurationSharingAccessesContent configurationId={configurationId} isAdmin={isAdmin} onReady={onContentReady} />
    </ModalDialog>
  );
};

export default ConfigurationSharingAccessesDialog;
